import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './containers/App'
import {createStore,combineReducers,applyMiddleware} from 'redux'
import {createLogger} from 'redux-logger'
import {Provider} from 'react-redux'
import thunk from 'redux-thunk'
import {scReducer} from './reducers/scReducer'


const store = createStore(combineReducers({scReducer}),
    {},
    applyMiddleware(createLogger(),thunk)
);


ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js